import Vue from 'vue'
import Router from 'vue-router'

import PageNotFound from '@/components/page/NotFound'

import admin from './modules/admin'
import auth from './modules/auth'
import user from './modules/user'

import statics from './modules/statics'

Vue.use(Router)

const routes = [
	// Homepage
	{
		path: '',
		name: 'HomePage',
		redirect: {
			name: 'AuthLogin'
		}
	},

	// Redirect other routes
	/* {
		path: '*',
		redirect: '/dashboard'
	} */
	{
		path: '*',
		components: {
			default: PageNotFound,
			//menu: Navigation // Can't show navigation here because the user might be anonymous (not logged in)
		},
	}
]

export default new Router({
	mode: 'history',
	// hashbang: false,
	base: __dirname,
	routes: [
		...routes,
		...user,
		...admin,
		...auth,
		...statics
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js